var map = {
	"./calin.png": "12e7",
	"./full/calin.png": "280b",
	"./full/marina.png": "2a91",
	"./full/marius.png": "826a",
	"./full/mihai.png": "b64b",
	"./full/vasile.png": "63d9",
	"./marina.png": "2990",
	"./marius.png": "af54",
	"./mihai.png": "67d1",
	"./vasile.png": "04ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2236";